<template>
    <div>
        <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"/>
        <b-card style="margin: 20px">
            <b-card-header header-tag="header" class="p-1" role="tab">Configuración</b-card-header>
            <b-card-body>
                <div
                    v-for="(item,index) in configurationItems"
                    @click="configurationItemClicked(item.route)"
                    v-bind:key="index">
                    <div v-if="itemShouldShow(item)" class="row" style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0">
                        <div class="col-10">
                            <i :class="item.icon"/>
                            <span style="vertical-align: middle; padding-left: 10px;">{{item.name}}</span>
                        </div>
                        <div class="col-2 text-right">&gt;</div>
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "Configuration",
    components: {
    },
    data() {
        return {
            configurationItems: [{
                itemID: 1,
                name: "Validación de Identidad",
                icon: "fa fa-fw fa-id-card",
                route: "verificacionidentidad",
                showForAssociatedCommerce: false,
                profiles: [{
                    id: 1,
                    name: "Admin en Cliente"
                }, {
                    id: 2,
                    name: "Admin en Comercio"
                }]
            }, {
                itemID: 2,
                name: "Preguntas Frecuentes",
                icon: "fa fa-fw fa-question",
                route: "faqs",
                showForAssociatedCommerce: true,
                profiles: [{
                    id: 1,
                    name: "Admin en Cliente"
                }, {
                    id: 2,
                    name: "Admin en Comercio"
                }]
            }, {
                itemID: 3,
                name: "Pin",
                icon: "fa fa-fw fa-key",
                route: "pin",
                showForAssociatedCommerce: true,
                profiles: [{
                    id: 1,
                    name: "Admin en Cliente"
                }, {
                    id: 2,
                    name: "Admin en Comercio"
                }]
            }, {
                itemID: 4,
                name: "Verificación en dos pasos",
                icon: "fa fa-fw fa-key",
                route: "verificaciondospasos",
                showForAssociatedCommerce: true,
                profiles: [{
                    id: 1,
                    name: "Admin en Cliente"
                }, {
                    id: 2,
                    name: "Admin en Comercio"
                }]
            }]
        };
    },
    computed: {
        profileID() {
            return this.$store.getters.profileID;
        },
        isAssociatedCommerce() {
            return this.$store.getters.isAssociatedCommerce;
        }
    },
    methods: {
        configurationItemClicked(route) {
            this.$router.push(route);
        },
        profileValidate(profiles) {
            return profiles.some(p => p.id == this.profileID);
        },
        showItem(itemID) {
            if(itemID == 4)            
                return this.$store.getters.DOUBLEFACTORSECENABLE;
            else
                return true;
        },
        itemShouldShow(item) {
            if (!this.showItem(item.itemID)) {
                return false;
            }

            if (this.isAssociatedCommerce) {
                return item.showForAssociatedCommerce === true;
            }

            return this.profileValidate(item.profiles);
        }
    }
}
</script>